/* eslint-disable import/no-cycle */
import { axios } from '../../config/axios';

const API_PATH = 'api/v1';
const API_URL = `${process.env.VUE_APP_API_URL}/${API_PATH}`;

const url = (endpoint) => {
  let route;
  if (endpoint.startsWith(`/${API_PATH}`)) {
    route = endpoint.substr(`/${API_PATH}`.length + 1);
  } else if (endpoint.startsWith('/')) {
    route = endpoint.substr(1);
  }
  return `${API_URL}/${route}`;
};

const options = (params, headers) => ({
    headers: headers || {},
    params: params || {},
});


export default {

  getApiUrl() {
    return API_URL;
  },

  get(endpoint, params, headers) {
    return axios.get(url(endpoint), options(params, headers));
  },

  post(endpoint, params, headers) {
    return axios.post(url(endpoint), params, headers);
  },

  put(endpoint, params, headers) {
    return axios.put(url(endpoint), params, headers);
  },

  patch(endpoint, params, headers) {
    return axios.patch(url(endpoint), params, headers);
  },

  delete(endpoint, params, headers) {
    return axios.delete(url(endpoint), options(params, headers));
  },

  getFile(endpoint, onDownloadProgress) {
    return axios(endpoint.startsWith('http') ? endpoint : url(endpoint), {
      responseType: 'blob',
      onDownloadProgress,
    });
  },
};

export { url };
